export const DATA_SOURCE_TYPE = { OpenBanking: 'OpenBanking', CreditInformation: 'CreditInformation' } as const;
export type DataSourceType = (typeof DATA_SOURCE_TYPE)[keyof typeof DATA_SOURCE_TYPE];
